import React from 'react';
import { ArrowUpRight, ArrowDownRight, BoxIcon } from 'lucide-react';
interface StatCardProps {
  label: string;
  value: string;
  trend: string;
  trendUp?: boolean;
  icon: BoxIcon;
  color?: 'blue' | 'green' | 'violet' | 'amber';
}
export function StatCard({
  label,
  value,
  trend,
  trendUp = true,
  icon: Icon,
  color = 'blue'
}: StatCardProps) {
  const colors = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-emerald-50 text-emerald-600',
    violet: 'bg-violet-50 text-violet-600',
    amber: 'bg-amber-50 text-amber-600'
  };
  return <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-62">
      <div className="flex justify-between items-start mb-4" data-id="element-63">
        <div className={`p-3 rounded-lg ${colors[color]}`} data-id="element-64">
          <Icon className="w-6 h-6" data-id="element-65" />
        </div>
        <div className={`flex items-center gap-1 text-xs font-bold px-2 py-1 rounded-full ${trendUp ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`} data-id="element-66">
          {trendUp ? <ArrowUpRight className="w-3 h-3" data-id="element-67" /> : <ArrowDownRight className="w-3 h-3" data-id="element-68" />}
          {trend}
        </div>
      </div>
      <div data-id="element-69">
        <p className="text-slate-500 text-sm font-medium mb-1" data-id="element-70">{label}</p>
        <h3 className="text-2xl font-bold text-slate-900" data-id="element-71">{value}</h3>
      </div>
    </div>;
}